import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { getShooting } from '../../../providers/api/shooting/shootingProvider';
import { Shooting } from '../../../providers/api/dtos';

export const SHOOTING_RID = '/shootings/:id';

export default function useShooting(
  shootingId?: Shooting['id'],
  options?: SWRConfiguration<Shooting, AxiosError>,
): SWRResponse<Shooting, AxiosError> {
  const key = shootingId ? [SHOOTING_RID, shootingId] : null;

  return useSWR(key, () => getShooting(shootingId!), options);
}
